import { Typography } from '@mui/material'

export const AdminResume = (): JSX.Element => {
  return (
    <Typography variant="h5" color="secondary.main">
      Dashboard
    </Typography>
  )
}
